import { render, staticRenderFns } from "./WannaStartup.vue?vue&type=template&id=9412b534&scoped=true&"
import script from "./WannaStartup.vue?vue&type=script&lang=js&"
export * from "./WannaStartup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9412b534",
  null
  
)

export default component.exports